/*
<purpose>
  The FE's single version-truth reader. Values are baked at build time by deploy-customer.sh
  (REACT_APP_VERSION from package.json, REACT_APP_BUILD_SHA, REACT_APP_BUILD_DATE). An
  uninjected build reports 'dev' — the footer never shows a fabricated number.
</purpose>
<dependencies>process.env (CRA build-time inlining).</dependencies>
<constraints>Source of the version NUMBER is frontend/package.json — bump it in the same PR
as any frontend change (see smarttix-receiver.md § "Versioning"). No other version file exists.</constraints>
*/

export interface VersionInfo {
  version: string;
  sha: string | null;
  buildDate: string | null;
}

export function getVersionInfo(): VersionInfo {
  return {
    version: process.env.REACT_APP_VERSION || 'dev',
    sha: process.env.REACT_APP_BUILD_SHA || null,
    buildDate: process.env.REACT_APP_BUILD_DATE || null,
  };
}

// Extracted verbatim from the App footer IIFE — de-DE short format with a tolerant parse
// for the legacy 'DD.MM.YYYY HH:mm' shape older deploy tooling emitted.
export function formatBuildDate(raw: string | null): string {
  if (!raw) return '–';
  try {
    let d = new Date(raw);
    if (isNaN(d.getTime()) && /^\d{1,2}\.\d{1,2}\.\d{4}\s+\d{1,2}:\d{2}$/.test(raw.trim())) {
      const [datePart, timePart] = raw.trim().split(/\s+/);
      const [day, month, year] = datePart.split('.').map(Number);
      const [hour, minute] = timePart.split(':').map(Number);
      d = new Date(Date.UTC(year, month - 1, day, hour, minute));
    }
    if (!isNaN(d.getTime())) return d.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' });
  } catch (_) { }
  return raw.replace(/\s*UTC\s*$/i, '');
}
